import {AxiosInstance} from "axios";
//import {inspect} from 'util'
const axios = require('axios').default;
import {Observable} from 'rxjs';
import {retry} from "rxjs/internal/operators";
//var pjson = require('./package.json');

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0'; //needed to get around UNABLE_TO_VERIFY_LEAF_SIGNATURE error returned by OV2500 (not Cirrus): Certificate issue

export class CirrusAPI {
    private cirrus: AxiosInstance;
    // @ts-ignore
    public token: string = '';
    public cookie: string = '';

    constructor(host: string) {
        this.cirrus = axios.create({
            baseURL: `https://${host}/api/`,
            timeout: 20000,
            rejectUnauthorized: false,
            //withCredentials: true,  TODO verify if adding this avoids keeping track of the cookie
        });
    }

    get version() {return `${'Version cirrus-node : 0.1.29'}`;}

    get headers() {
        return {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Ov-App-Version': '4.4R2',
            'Cookie': this.cookie.toString()
        }
    }

    login(data: CirrusAPI.loginData) {
        return new Promise((resolve, reject) => {
            this.cirrus.post('login', {
                userName: data.username,
                password: data.password,
            }, {headers: this.headers})
                .then((response) => {
                    this.token = response.data.accessToken;
                    this.cookie = response.headers['set-cookie'];
                    resolve(true)
                }).catch((err) => {
                console.log(`Got login failed for ${data.username}`, err);
                reject(false)
            });
        });
    }

    about(): Promise<CirrusAPI.ABOUT_DATA> {
        return new Promise<CirrusAPI.ABOUT_DATA>((resolve, reject) => {
            this.cirrus.get('about', {headers: this.headers})
                .then((response) => {
                    let about: CirrusAPI.ABOUT_DATA = response.data;
                    resolve(about)
                }).catch((err) => {
                //console.log(err);
                reject(err)
            });
        })
    }

    getIotInventoryWithRetry(): Observable<CirrusAPI.IOTINVENTORY_DATA[]> {
        return new Observable<CirrusAPI.IOTINVENTORY_DATA[]>(observable => {
            this.cirrus.post('iot/inventory', new OV_getIotInventory(), {headers: this.headers})
                .then((resultSet) => {
                    let cirrusResponse: CirrusAPI.CIRRUS_RESPONSE = resultSet.data;
                    if (cirrusResponse.response.hasOwnProperty('ioTInventoryVOs')) {
                        observable.next(cirrusResponse.response.ioTInventoryVOs);
                    } else observable.error("getIotInventoryWithRetry Bad response format");
                    observable.complete()
                })
                .catch((err) => {
                    console.log("Got getIotInventoryWithRetry error", err);
                    observable.error(err)
                }).finally(()=>{})
        }).pipe(retry(3))
    }

    getDevices(): Promise<CirrusAPI.DEVICES_DATA[]> {
        return new Promise<CirrusAPI.DEVICES_DATA[]>((resolve, reject) => {
            this.cirrus.get('devices?fieldSetName=discovery', {headers: this.headers})
                .then((resultSet)=>{
                    let response:CirrusAPI.CIRRUS_RESPONSE = resultSet.data;
                    let devices: CirrusAPI.DEVICES_DATA[] = response.response;
                    //console.log("getDevices", devices);
                    resolve(devices)
                }).catch(err=>{reject(err)})
        })
    }

    getSsid(): Promise<CirrusAPI.SSID_DATA[]> {
        return new Promise<CirrusAPI.SSID_DATA[]>((resolve, reject) => {
            this.cirrus.get('ag/uatemplate/SSIDSimplification', {headers: this.headers})
                .then((resultSet)=>{
                    let response:CirrusAPI.CIRRUS_RESPONSE = resultSet.data;
                    let ssid: CirrusAPI.SSID_DATA[] = response.response;
                    resolve(ssid)
                }).catch(err=>{reject(err)})
        })
    }

    updateSsidStatus(ssidInstanceId: string, status: boolean) {
        return new Promise<any>((resolve,reject) => {
            this.cirrus.put(`ag/ssid/${status?'enable':'disable'}`, new OV_updateSsidStatus(ssidInstanceId), {headers: this.headers})
                .then((resultSet) => {
                    resolve(resultSet.data)
                })
                .catch((err) => {
                    console.log("Got updateSsidStatus error", err);
                    reject(err)
                }).finally(()=>{})
        })
    }

    addVlan(deviceId:string, vlan: string ) {
        console.log(`Adding VLAN ${vlan} for ${deviceId}`);
        return new Promise<any>((resolve,reject) => {
            this.cirrus.post(`vlanservice/devices/vlans/`, {data:new OV_addVlanData(deviceId,vlan)}, {headers: this.headers})
                .then((resultSet) => {
                    resolve(resultSet.data)
                })
                .catch((err) => {
                    console.log("Got addVlan error", err);
                    reject(err)
                }).finally(()=>{})
        })
    }
    deleteVlan(deviceId:string, vlan: number ) {
        return new Promise<any>((resolve,reject) => {
            this.cirrus.delete(`vlanservice/devices/vlans/`, {data:{data:new OV_deleteVlanData(deviceId,vlan)}, headers: this.headers})
                .then((resultSet) => {
                    resolve(resultSet.data)
                })
                .catch((err) => {
                    console.log("Got addVlan error", err);
                    reject(err)
                }).finally(()=>{})
        })
    }
}



export namespace CirrusAPI {
    export interface loginData {
        username: string;
        password: string;
    }

    enum ResultResponseType {IotInventoryResponse = "IotInventoryResponse"}
    enum ResponseType {RESPONSE_SYNCHRONOUS="RESPONSE_SYNCHRONOUS", ArrayList="ArrayList" }

    export interface Response {
        "response": ResponseType,
        "finalResponse": true,
        "message": { "code": string, "params": [] },
        "ioTInventoryVOs"?: IOTINVENTORY_DATA[],
        "pageSize": number,
        "pageNumber": number,
        "numberOfPages": number,
        "totalNumberOfRecords": number,
        "translated": { "messageObjects": {}, "numberOfPagesTranslated": "1", "finalResponseTranslated": "true", "ioTInventoryVOs": [], "messageTranslated": "", "responseTranslated": "RESPONSE_SYNCHRONOUS", "totalNumberOfRecordsTranslated": "26", "pageNumberTranslated": "1", "pageSizeTranslated": "1,000" }
    }

    export interface CIRRUS_RESPONSE {
        "status": string,
        "statusCode": number,
        "type": ResultResponseType,
        "response": any,
        "serverVersion": string
    }

    export interface DEVICES_DATA {
        deviceType: string
        name: string
        ipAddress: string
        model: any
        version: string
        location: string
        geoLocation: string
        geoLocationAddress: ""
        deviceDNS: ""
        deviceLastUpgradeStatus: ""
        backupDate: Date
        backupVersion: any
        lastKnownUpAt: Date
        description: string
        status: string
        traps: string
        seenBy: string
        runningFrom: string
        iotStatus: string
        changes: string
        discoveredDateTime: Date
        macAddress: string
        sync: boolean
        supportsSsh: boolean
        allowPortDisabling: boolean
        licenseType: string
        featureIds: any
        friendlyName: string
        vpnIp: string
        dataVPNConnectivityStatus: any
        others: {}
        discoverLinks: string
        groupName: any
        instanceid: string
    }

    export interface SSID_DATA {
        a_mpdu: string
        a_msdu: string
        aaaProfileForExternalCP: string
        aaaServerProfileName: string
        accessPolicyName: string
        accessPolicyOption: string
        accessRoleProfileName: string
        accessRoleTab: string
        aclAndQos: []
        allowBand: string
        appliedAPGroups: string[]
        arpCreatedName: string
        authenticationDatabase: string
        authenticationStrategyName: string
        broadcastFilterARP: "disable"
        broadcastFilterAll: "disable"
        broadcastKeyRotation: "disable"
        broadcastKeyRotationTimeInterval: 15
        byodAccessStrategyName: null
        byodRegistration: false
        bypassStatus: null
        classificationStatus: "disable"
        clientConnectionLoggingLevel: "NONE"
        clientIsolation: "disable"
        clientSessionLogging: "disable"
        clientsNumber: 6
        deviceSpecificPSK: "DISABLED"
        dhcpOpt82Config: "disable"
        domainList: null
        dot1pDownlinkBackground: [1, 2]
        dot1pDownlinkBestEffort: [0, 3]
        dot1pDownlinkVideo: [4, 5]
        dot1pDownlinkVoice: [6, 7]
        dot1pMappingEnable: "enable"
        dot1pUplinkBackground: 1
        dot1pUplinkBestEffort: 0
        dot1pUplinkVideo: 4
        dot1pUplinkVoice: 6
        downstreamBandwidth: 0
        downstreamBurst: 0
        dscpDownlinkBackground: [8, 16]
        dscpDownlinkBestEffort: [0, 24]
        dscpDownlinkVideo: [32, 40]
        dscpDownlinkVoice: [48, 56]
        dscpMappingEnable: "enable"
        dscpUplinkBackground: 8
        dscpUplinkBestEffort: 0
        dscpUplinkVideo: 32
        dscpUplinkVoice: 48
        dtimInterval: 1
        e0211bClientSupport: "enable"
        e0211gClientSupport: "enable"
        e0211kStatus: "disable"
        e0211rStatus: "disable"
        e0211vStatus: "disable"
        employeeDatabase: null
        encryptionType: "WPA2_PSK_AES"
        entropyStatus: "disable"
        essid: "Dees netwerk"
        externalCaptivePortal: "disable"
        externalCaptivePortalConfig: null
        guestAccessStrategyName: null
        guestPortal: false
        hideSSID: "disable"
        hotspot20Status: "disable"
        httpsRedirection: "enable"
        instanceid: string
        l3Roaming: "disable"
        localBreakoutStatus: "disable"
        locationPolicy: null
        loginBy: null
        macAllowEap: null
        macAuthPassProfileName: null
        macAuthStatus: "disable"
        maxClientsPerBand: 64
        maxEgressBandwidth: null
        maxEgressDepth: null
        maxIngressBandwidth: null
        maxIngressDepth: null
        migratedSSID: false
        minBasicDataRate5G: 6000
        minBasicDataRate5GStatus: "disable"
        minBasicDataRate24G: 1000
        minBasicDataRate24GStatus: "disable"
        minSupportedDataRate5G: 6000
        minSupportedDataRate5GStatus: "disable"
        minSupportedDataRate24G: 1000
        minSupportedDataRate24GStatus: "disable"
        multicastChannelUtilization: 90
        multicastOptimization: "enable"
        name: string
        networkType: string
        okcStatus: "disable"
        operationName: null
        passphrase: "*****"
        periodPolicy: null
        pmf: "Disabled"
        port: null
        portalPage: null
        portalServer: ""
        portalType: "No"
        preSharedKey: null
        radiusServer: null
        radiusServerProfileName: null
        redirectUrl: ""
        roamingConsortiumOIList: null
        securityLevel: "Personal"
        securityLevelUI: "protectedGuests"
        selfRegistration: null
        socialLogin: null
        socialLoginVendors: []
        ssidStatus: "enable"
        staticRoutes: null
        translated: any
        trustOriginalDSCP: "disable"
        ttsIpAddress: null
        tunnelId: null
        tunnelProfileName: null
        tunnelType: null
        upstreamBandwidth: 0
        upstreamBurst: 0
        urlToRedirect: null
        useNATOverTunnel: false
        venueName: null
        venueType: null
        version: 4
        vlanId: 0
        vlanRange: ["0"]
        wListDomains: []
        wepKeyIndex: null
        wlanTimer: any
    }

    export interface ABOUT_DATA {
        productName: string
        revision: string
        designation:string
        buildNumber: string
        buildDate: string
        fullProductName: string
        others: {upamVersion: string, changeList: string, wmaVersion: string}
    }
    export interface IOTINVENTORY_DATA {
        "deviceInstanceId": string,
        "macAddress": string,
        "deviceMac": string,
        "friendlyName": string,
        "ipAddress": string,
        "startTime": Date,
        "stopTime": Date,
        "status": string,
        "lastUpdated": Date,
        "manufacturer": string,
        "endpointversion": string,
        "score": number,
        "agContext": { "unp": string, "unpType": string, "policyList": string, "authType": string, "authStatus": string, "connError": string },
        "networkContext": { "port": string, "portType": string, "portDescription": string, "vlan": number, "vpnID": number, "farEndIP": string },
        "prof": { "opt55": any, "opt60": any, "userAgents": any, "hosts": any },
        "category": { "categoryName": string, "type": string, "hierarchy": any }
    }
    export interface OVNOTIFICATION_DATA {
        'instanceId': number,
        'snmpVersion': number,
        'date': Date,
        'uptime': number,
        'synopsis': string,
        'desc': string,
        'acked': boolean,
        'name': string,
        'severity': string,
        'agentIp': string,
        'agentSysName': string,
        'sourceIp': string,
        'trapOID':string,
        'snmpVars': [
            {
                'name': string,
                'value': string,
                'desc': string
            }
        ],
        'enterprise': string,
        'enterpriseOID': string,
        'generic': number,
        'specific': number,
        'groupName': string,
        'macAddress': string,
        'deviceId': string,
        'snmpV1SpecificTrapKeyList': []
    }
}

class OV_updateSsidStatus {
    UnifiedProfileAssignRequestObject:{documentIds:string[]};
    constructor(ssidInstanceId: string) {
        this.UnifiedProfileAssignRequestObject = {
            documentIds: [ssidInstanceId],
        }
    }
}

class OV_getIotInventory {
    constructor() {
    }

    type = "IotInventoryRequest";
    endpointStatus = "All";
    filterBy = "ALL";
    macAddresses = [];
    categories = [];
    unps = [];
    ssids = [];
    deviceMap = {};
    apGroups = null;
    mapIds = null;
    timeRange = null;
    pageSize = 1000;
    pageNumber = 1;
    debugMode = false;
    latestRecords = true;
}

class OV_addVlanData {
    "vlanNumber":string[] = [];
    "unTaggedPortTemplate":[] = [];
    "taggedPortTemplate":[]=[];
    "overWrite":boolean = false;
    "vlanTableInfo":VlanTableInfo[] = [];
    "defaultVlanNumber":string = '';
    constructor(deviceId: string, vlan: string) {
        this.vlanNumber.push(vlan);
        this.vlanTableInfo.push(new VlanTableInfo(deviceId))
    }
}
class OV_deleteVlanData {
    "deviceInfos":{"deviceId":string}[]=[];
    "vlanNumber":number=0;
    "vlanTableInfo":{"vlanInfo":{"number":number}}[]=[];
    constructor(deviceId: string, vlan: number) {
        this.deviceInfos.push({"deviceId":deviceId});
        this.vlanTableInfo.push({"vlanInfo":{"number":vlan}})
    }
}

class VlanTableInfo {
    "deviceId":string = '';
    "useTaggedPortTemplate":boolean= true;
    "useUnTaggedPortTemplate":boolean = true;
    "vlanInfo":{"number":0;"description":"";"admStatus":"enabled"};
    "tagged":[]=[];
    "untagged":[];
    constructor(deviceId: string) {
        this.deviceId = deviceId;
    }
}

/*
var c = new CirrusAPI("antwerp.ov.ovcirrus.com");
c.login({username: 'devrard', password: "aleCIRRUS#1"}).then(()=>{
    //c.getIotInventoryWithRetry().subscribe((data)=>{console.log("Retrieved iot list:",data);})
    //c.getDevices().then(data=>{console.log("devices", data)})
})*/


